<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5002 16.0468L4.2053 24.3417L0.358398 20.4948L8.65328 12.1999L0.358398 3.90501L4.2053 0.0581055L12.5002 8.35298L20.7951 0.0581055L24.642 3.90501L16.3471 12.1999L24.642 20.4948L20.7951 24.3417L12.5002 16.0468Z" fill="#010101"/>
  </svg>
</template>